import React from 'react';
import { useDroppable } from '@dnd-kit/core';

type SortableDropZoneProps = {
  id: string;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  ready?: boolean;
  readyStyle?: React.CSSProperties;
  overStyle?: React.CSSProperties;
};

const SortableDropZone = ({
  id,
  disabled = false,
  children,
  className,
  style,
  ready = false,
  readyStyle,
  overStyle,
}: SortableDropZoneProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      className={className}
      style={{
        minHeight: 24,
        borderRadius: 8,
        transition: 'background-color 120ms ease',
        ...style,
        ...(ready ? readyStyle : undefined),
        ...(isOver ? overStyle : undefined),
      }}
    >
      {children}
    </div>
  );
};

export default SortableDropZone;
